import React from 'react';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { ISeo } from 'base/interfacesV2/seo';
import { useStoreState } from 'base/store';
import getCanonicalUrl from 'base/utils/getCanonicalUrl';
import site from 'pro/config/site';
import * as i18nNextConfig from 'pro/config/next.config';

type PageSeoProps = {
    seoProps: ISeo;
    pageProps?: {
        seo?: {
            canonicalUrl?: string;
        }
    };
};

const PageSeo: React.FC<PageSeoProps> = ({ seoProps, pageProps }) => {
    const rootState = useStoreState('rootStore');
    const { asPath } = useRouter();

    const searchQuery = rootState.query.q || ''
    const description = seoProps?.description || site.brand
    const pageCode = rootState.pageCode
    const lang = rootState.lang
    const country = rootState.country
    const host = rootState.host

    let keywords = seoProps?.keywords || site.brand;
    if (searchQuery) {
        keywords = `${searchQuery}, ${searchQuery} ${site.brand}, ${keywords}`;
    }

    const canonicalUrl = pageProps?.seo?.canonicalUrl || getCanonicalUrl(asPath.replace(/\?.*$/, ''), rootState.query, rootState.queryKeys);
    const locale = lang === 'en' && country === 'US' ? '' : `/${lang}-${country}`;

    const title = searchQuery || seoProps?.title || site.brand

    return (
        <NextSeo
            title={title}
            description={description}
            additionalMetaTags={[
                {
                    name: 'Keywords',
                    content: keywords,
                }
            ]}
            openGraph={{
                type: pageCode === 'detail' ? 'product' : 'website',
                images: [
                    {
                        url: seoProps?.image || site.seo.image,
                        width: 600,
                        height: 600,
                        alt: title,
                    },
                ],
            }}
            canonical={`https://${site.domain}${locale}${canonicalUrl}`}
            languageAlternates={[
                ...i18nNextConfig.i18n.locales.map(locale => ({
                    hrefLang: locale,
                    href: `https://${host}/${locale}${canonicalUrl}`
                })),
                {
                    hrefLang: 'x-default', href: `https://${host}${canonicalUrl}`
                }
            ]}
            facebook={
                site.facebook?.appId
                    ? { appId: site.facebook.appId }
                    : void 0
            }
        />
    )
};

export default PageSeo;